import { render } from "./WechatHint.vue?vue&type=template&id=1a583b19&scoped=true"
import script from "./WechatHint.vue?vue&type=script&lang=js"
export * from "./WechatHint.vue?vue&type=script&lang=js"

import "./WechatHint.vue?vue&type=style&index=0&id=1a583b19&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a583b19"]])

export default __exports__